



















import Vue from 'vue';

import Modal        from "@/components/Modal.vue";
import importDeck   from '@/lib/helpers/importDeck';

export default Vue.extend({
    props: ['showImportModal'],
    data() {
        return {
            isVisible: false,
        }
    },
    components: {
        Modal,
    },
    methods: {
        importClick() {
            importDeck(this.currentUser.uid)
            .then(val => {
                this.$toast.open({
                    message: 'Upload complete!  Deck will be imported shortly.',
                    type: 'success',
                    duration: 3000,
                    position: 'top-right'
                });
                this.isVisible = false;
            })
            .catch(err => {
                this.toastAndError(this, 'There was an error with the upload.  Please try again.', err);
                this.isVisible = false;
            })
        }
    },
    watch: {
        showImportModal () {
            this.isVisible = !this.isVisible
        },
    },
})
